import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import moment from "moment";
import { isSgdMeetingCredit } from "utils/meetingRoomCredit";
import {
  fetchAgreementByIdRequest,
  getAgreementByIdState,
} from "redux/reducers/smartSuiteAgreement";


const SmartSuiteAgreementComponent = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const { Panel } = Collapse;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const _id = queryParams.get("id");
    const token = queryParams.get("token");
    localStorage.setItem("auth_token", token);
    localStorage.setItem("isPublic", true);
    dispatch(fetchAgreementByIdRequest({ id: _id }));
  }, [dispatch]);
  const response = useSelector(getAgreementByIdState);
  useEffect(() => {
    if (!response) return;
    setData(response.data?.data);
  }, [response]);
  return (
    <>
      <div className="content-overlay"></div>
      <div className="content-wrapper">
        <div className="content-header row m-5">
          <div className="content-header-left col-md-12 mb-2">
            <div className="list-group">
              <div
                className="list-group-item list-group-item-action "
                style={{ backgroundColor: "#ccdcf1" }}
              >
                <div className="content-header-title">
                  OFFICE SERVICE AGREEMENT
                </div>
              </div>
              <div className="list-group-item list-group-item-action ">
                <div className="content-header row col-md-12">
                  <div className="content-header-left col-md-6 mb-2">
                    <div className="content-header-action ">
                      <div className="agreement-table-name">
                        Agreement Date(dd/mm/yy)
                      </div>
                      <div className="agreement-table-name">
                        {moment(data?.agreementDate).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  </div>
                  <div className="content-header-right col-md-6 mb-2">
                    <div className="content-header-action float-end">
                      <div className="agreement-table-name">
                        Smart Suite Agreement
                      </div>
                      <div className="agreement-table-name ">
                        Reference No.: {data?.alternateId ?? "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="content-header row col-md-12">
                  <div className="content-header-left row col-md-6 mb-2 ">
                    <div className="content-header-action">
                      <Collapse
                        defaultActiveKey={["1", "2"]}
                        expandIconPosition={"right"}
                        expandIcon={({ isActive }) =>
                          isActive ? <MinusOutlined /> : <PlusOutlined />
                        }
                        className="details-heading"
                      >
                        <Panel
                          header="BUSINESS CENTER ADDRESS"
                          className="location-details custom-sw-pannel mb-5"
                          key="1"
                        >
                          <div className="canvas-section-row mx-2 my-3">
                            <div className="col view-label my-1">
                              SMARTWORKS COWORKING SPACES PRIVATE LIMITED
                            </div>
                            <div className="col view-information my-1">
                              {data?.floor?.name ?? "N/A"}
                            </div>
                          </div>
                        </Panel>
                        <Panel
                          header="TAN, PAN & GST DETAILS"
                          className="location-details custom-sw-pannel  mb-5"
                          key="2"
                        >
                          <div className="common-data-container">
                            <div className="table-responsive">
                              <table className="table table-bordered">
                                <tbody className="font-w-600">
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        GST NO.{" "}
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.gst || "Unregisted"}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        PAN NO.{" "}
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.pan || " N/A "}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        TAN NO.{" "}
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.tan || " N/A "}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  </div>
                  <div className="content-header-right row col-md-6 mb-2 ">
                    <div className="content-header-action float-end">
                      <Collapse
                        defaultActiveKey={["1", "2"]}
                        expandIconPosition={"right"}
                        expandIcon={({ isActive }) =>
                          isActive ? <MinusOutlined /> : <PlusOutlined />
                        }
                        className="details-heading"
                      >
                        <Panel
                          header="CLIENT ADDRESS(NOT A CENTER ADDRESS)"
                          className="location-details custom-sw-pannel  mb-5"
                          key="1"
                        >
                          <div className="common-data-container">
                            <div className="table-responsive">
                              <table className="table table-bordered">
                                <tbody className="font-w-600">
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Contact Name
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.contactPerson}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Company Name
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.company}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Regd. Office Address
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.registeredOfficeAddress}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Phone
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.telephone}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Email
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        {data?.email}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Contact email
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        N/A
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Contact phone
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        N/A{" "}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        Alternate Contact phone
                                      </div>
                                    </th>
                                    <td style={{ width: "50%" }}>
                                      <div className="agreement-table-name">
                                        N/A{" "}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  </div>
                </div>
                <div className="content-header row col-md-12">
                  <div className="content-header-action">
                    <Collapse
                      defaultActiveKey={["1", "2", "3", "4", "5", "6"]}
                      expandIconPosition={"right"}
                      expandIcon={({ isActive }) =>
                        isActive ? <MinusOutlined /> : <PlusOutlined />
                      }
                      className="details-heading"
                    >
                      <Panel
                        header="OFFICE PAYMENT DETAILS(EXCLUDING TAX/GST AND EXCLUDING SERVICES)"
                        className="location-details custom-sw-pannel mb-5"
                        key="1"
                      >
                        <div className="common-data-container">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th style={{ width: "40%" }}>
                                    <div className="agreement-table-name">
                                      Office Number
                                    </div>
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    <div className="agreement-table-name">
                                      No of Peaople
                                    </div>
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    <div className="agreement-table-name">
                                      Monthly Office Fee
                                    </div>
                                  </th>
                                  <th style={{ width: "520%" }}>
                                    <div className="agreement-table-name">
                                      Currency
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="font-w-600">
                                <tr>
                                  <td style={{ width: "40%" }}>
                                    <div className="agreement-table-name">
                                      {data?.selectedSeatsId?.toString() ??
                                        "N/A"}
                                    </div>
                                  </td>
                                  <td style={{ width: "20%" }}>
                                    <div className="agreement-table-name">
                                      {data?.noOfPeople ?? "N/A"}
                                    </div>
                                  </td>
                                  <td style={{ width: "20%" }}>
                                    <div className="agreement-table-name">
                                      {data?.monthlyFee ?? "N/A"}
                                    </div>
                                  </td>
                                  <td style={{ width: "20%" }}>
                                    <div className="agreement-table-name">
                                      S$
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Panel>
                      <Panel
                        header="INITITAL PAYMENT"
                        className="location-details custom-sw-pannel mb-5"
                        key="2"
                      >
                        <div className="common-data-container">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody className="font-w-600">
                                <tr>
                                  <th style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      First Month Fee **
                                    </div>
                                  </th>
                                  <td style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      {data?.firstMonthFee ?? "N/A"}
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      Customer Registration Fee ***
                                    </div>
                                  </th>
                                  <td style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      {data?.oneTimeRegistrationCharges || 0}
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      Service retainer ***
                                    </div>
                                  </th>
                                  <td style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      {data?.serviceRetainer ?? "N/A"}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Panel>
                      <Panel
                        header="TOTAL MONTHLY COMMITMENT"
                        className="location-details custom-sw-pannel mb-5"
                        key="3"
                      >
                        <div className="common-data-container">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody className="font-w-600">
                                <tr>
                                  <th style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      Total monthly commitment thereafter
                                    </div>
                                  </th>
                                  <td style={{ width: "50%" }}>
                                    <div className="agreement-table-name">
                                      {data?.monthlyFee ?? "N/A"}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Panel>
                      <Panel
                        header="AGREEMENT PERIOD"
                        className="location-details custom-sw-pannel mb-5"
                        key="4"
                      >
                        <div className="common-data-container">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody className="font-w-600">
                                <tr>
                                  <th style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      Start Date
                                    </div>
                                  </th>
                                  <td style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      {data?.startDate ?? "N/A"}
                                    </div>
                                  </td>
                                  <th style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      End Date
                                    </div>
                                  </th>
                                  <td style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      {data?.endDate ?? "N/A"}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Panel>
                      <Panel
                        header="SERVICE PROVISION"
                        className="location-details custom-sw-pannel mb-5"
                        key="5"
                      >
                        <div className="common-data-container">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody className="font-w-600">
                                <tr>
                                  <th style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      Lock-in Period
                                    </div>
                                  </th>
                                  <td style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      {data?.lockInPeriod ?? "N/A"}
                                    </div>
                                  </td>
                                  <th style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      Notice Period
                                    </div>
                                  </th>
                                  <td style={{ width: "25%" }}>
                                    <div className="agreement-table-name">
                                      {data?.noticePeriod ?? "N/A"}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Panel>
                      <Panel
                        header=""
                        className="location-details custom-sw-pannel mb-5"
                        key="6"
                      >
                        <div className="common-data-container">
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody className="font-w-600">
                                <tr>
                                  <th style={{ width: "16.66%" }}>
                                    <div className="agreement-table-name">
                                      REFURBISHMENT CLAUSE
                                    </div>
                                  </th>
                                  <td style={{ width: "16.66%" }}>
                                    <div className="agreement-table-name">
                                      {data?.refurbishment ?? "N/A"}
                                    </div>
                                  </td>
                                  <th style={{ width: "16.66%" }}>
                                    <div className="agreement-table-name">
                                      {isSgdMeetingCredit(data) ? "MEETING ROOM CREDIT (S$ PER MONTH)" : "MEETING ROOM HOURS (PER MONTH)"}
                                    </div>
                                  </th>
                                  <td style={{ width: "16.66%" }}>
                                    <div className="agreement-table-name">
                                      {isSgdMeetingCredit(data) ? (data?.meetingRoomCreditAmount ?? "N/A") : (data?.freeMeetingRoomHours ?? "N/A")}
                                    </div>
                                  </td>
                                  <th style={{ width: "16.66%" }}>
                                    <div className="agreement-table-name">
                                      CONFERENCE ROOM HOURS (PER MONTH)
                                    </div>
                                  </th>
                                  <td style={{ width: "16.66%" }}>
                                    <div className="agreement-table-name">
                                      {isSgdMeetingCredit(data) ? "N/A" : (data?.freeConfrenceRoomHours ?? "N/A")}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                </div>
                <div className="content-header row col-md-12 mx-2 ">
                  <div className="content-header-action row my-2">
                    <div className="row agreement-table-name">
                      Note: All agreements end on the last calender day of the
                      month
                    </div>
                    <div className="row agreement-table-name">
                      NOTE: Agreements printed before acceptance will be in
                      draft mode only.
                    </div>
                    <div className="row agreement-table-name">
                      **Payable on or before the start of the agreement
                    </div>
                    <div className="row agreement-table-name">
                      ***Payable immediately Note: Monthly Fees are adjusted
                      based on offer chosen
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmartSuiteAgreementComponent;
